import * as React from "react";
import { Table } from "../../../components/table";
import { Props, rowData, managersList } from "./types";
import { projectionsData, RegistrationUser } from "registerations/hooks/types";
import { makeStyles } from "@material-ui/core/styles";
import { TableHeader } from "./tableHeader";
import { FilterGroup } from "components/filter-group";
import { Pagination } from "@material-ui/lab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RegisterModal } from "../user-info-modal";
import {
  faIdCard,
  faFile,
  faUndo,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "10px",
    fontSize: "0.9rem",
    fontSizeAdjust: 0.38,
    "& tr": {
      height: "37px",
      "& span": {
        display: "inline-block",
        paddingLeft: "7px",
      },
    },
    "& td.fixedCol": {
      position: "sticky",
      zIndex: 99,
      background: "#fff",
    },
    "& .pos": {
      left: 0,
    },
    "& .name": {
      left: 40,
    },
    "& .tableFilters": {
      display: "flex",
      flexFlow: "row wrap",
      justifyContent: "space-between",
    },
  },
  plusIconUD: {
    color: "#F22B0C",
    cursor: "pointer",
  },
  plusIconFav: {
    color: "#238823",
    cursor: "pointer",
  },
  disabledIcon: {
    color: "rgba(0, 0, 0, 0.38)",
    cursor: "pointer",
  },
  disabled: {
    pointerEvents: "none",
  },
  search: {
    border: "none",
    width: 140,
    borderBottom: "1px solid #999",
    fontSize: 14,
    outline: "none",
  },
  modal: {
    position: "relative",
    overflow: "auto",
  },
  content: {
    overflow: "auto",
    position: "relative",
    top: "10%",
    left: "50%",
    transform: "translate(-50%, 0)",
    width: "70vw", // Decreased width for desktop view
    padding: "10px",
    borderRadius: "20px",
    backgroundColor: theme.palette.common.white,
    "& .column": {
      width: "100%",
      display: "block",
      marginBottom: "20px",
    },
    "& .profileName": {
      margin: "5px 0",
      textAlign: "center",
      fontSize: "1.3rem", // Decreased font size for desktop view
      fontWeight: "bold",
    },
    "& .profileSection": {
      margin: "15px",
      color: "#0a2540",
      padding: "8px 20px",
      borderRadius: "15px",
      backgroundColor: "#f0f0f1",
      overflow: "auto",
      "& strong": {
        fontSize: "1rem",
      },
      "& p": {
        fontSize: "0.9rem",
        padding: "6px",
      },
      "& .fonticon": {
        color: "#4682b4",
        "& :hover": {
          color: "#01528e",
        },
      },
      "& .iconBlock": {
        display: "inline-block",
        width: "85px",
        textAlign: "center",
        wordWrap: "break-word",
        lineHeight: "1.4"
      },
    },
    // Mobile adjustments
    "@media (max-width: 600px)": {
      top: "5%",
      width: "95vw",
      padding: "5px",
      borderRadius: "10px",
      "& .column": {
        marginBottom: "10px",
      },
      "& .profileName": {
        padding: "8px 12px",
        fontSize: "1.3rem",
      },
      "& .profileSection": {
        margin: "10px",
        padding: "5px 15px",
      },
    },
  },
  

  managerButton: {
    border: "none",
    backgroundColor: "#4682b4",
    color: "#fff",
    padding: "10px 16px",
    textAlign: "center",
    textDecoration: "none",
    display: "flex",
    fontSize: "16px",
    margin: "4px 2px",
    transitionDuration: "0.4s",
    cursor: "pointer",
    justifyContent: "end",
    borderRadius: "6px",

    "&:hover": {
      backgroundColor: "#01528e",
      color: "#fff",
    },

    [theme.breakpoints.down("xs")]: {
      // Apply the following styles on extra small screens (mobile devices)
      padding: "6px 10px", // Reduce padding for smaller size
      fontSize: "14px", // Adjust font size for smaller size
    },
  },

  dateFilterButton: {
    backgroundColor: "#fff",
    color: "#999",
    borderColor: "#ccc",
    borderStyle: "solid",
    borderWidth: 1,
    padding: "6px 10px",
    textAlign: "center",
    textDecoration: "none",
    display: "flex",
    fontSize: "13px",
    margin: "4px 2px",
    transitionDuration: "0.4s",
    cursor: "pointer",
    justifyContent: "end",
    borderRadius: "6px",

    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
  },

  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    paddingBottom: "4px",
    [theme.breakpoints.down("xs")]: {
      // Apply the following styles on extra small screens (mobile devices)
      flexFlow: "column", // Stack buttons vertically on mobile
    },
  },

  managersListButton: {
    background: "none",
    color: "#999",
    padding: "6px 10px",
    textAlign: "center",
    textDecoration: "none",
    display: "flex",
    fontSize: "15px",
    margin: "4px 2px",
    transitionDuration: "0.4s",
    cursor: "pointer",
    justifyContent: "end",

    "&:hover": {
      color: "#f4553c",
    },

    [theme.breakpoints.down("xs")]: {
      // Apply the following styles on extra small screens (mobile devices)
      padding: "4px 6px", // Reduce padding for smaller size
      fontSize: "12px", // Adjust font size for smaller size
      order: 2,
    },
  },

  dateFilterBox: {
    overflow: "hidden",
    position: "relative",
    top: "8%",
    left: "50%",
    transform: "translate(-50%, 0%)",
    width: "62vw",
    height: "60vh",
    padding: "20px",
    borderRadius: "40px",
    backgroundColor: theme.palette.common.white,
    boxShadow: "0px 4px 30px -5px rgba(0,0,0,0.65)",

    "@media(max-width:900px)": {
      height: "46vh",
    },

    "& .dateRangeDesktop": {
      "@media(max-width:913px)": {
        display: "none",
      },
    },

    "& .dateRangeMobile": {
      "@media(min-width:913px)": {
        display: "none",
      },
    },
  },

  managersListModal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  managersListBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40vw",
    maxWidth: "250px", // Adjust based on your design
    maxHeight: "60vh", // Adjust based on your design
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.3)",
    overflow: "auto",
    boxSizing: "border-box",
  },
  styledTable: {
    width: "100%",
    fontSize: "1em", // Adjusted font size for better readability,
    borderCollapse: "collapse",
    "& thead": {
      backgroundColor: "#4682b4",
      color: "#ffffff",
      textAlign: "center",
      "& th": {
        padding: "12px 15px",
        borderBottom: "1px solid #565b5e", // Add bottom border for separation
        fontSize: "1.1em", // Adjusted font size for the header
      },
    },
    "& tbody": {
      "& tr": {
        borderBottom: "1px solid #ccc",
        transition: "background-color 0.3s ease", // Add transition effect on hover
        "&:hover": {
          backgroundColor: "#f7f7f7", // Add a subtle background color on hover
        },
        "& td": {
          padding: "10px 15px",
          textAlign: "center",
        },
      },
    },
  },

  resetButtonStyle: {
    padding: "8px 10px",
    backgroundColor: "white",
    color: "#f4553c",
    border: "solid 2px",
    borderRadius: "4px",
    borderColor: "#f4553c",
    cursor: "pointer",
    transition: "background-color 0.3s, color 0.3s", // Add transition for smooth effect
    "&:hover": {
      backgroundColor: "#f4553c",
      color: "white",
      "& .resetButtonIcon": {
        color: "white",
      },
    },
    [theme.breakpoints.down("xs")]: {
      // Apply the following styles on extra small screens (mobile devices)
      padding: "4px 5px", // Reduce padding for smaller size
      fontSize: "12px",
      margin: "0 8px", // Adjust font size for smaller size
    },
  },
  // tableHeaderCell: {
  //   padding: '12px 15px',
  // },
  // tableBodyRow: {
  //   borderBottom: '1px solid #dddddd',
  // },
  // evenTableRow: {
  //   backgroundColor: '#f3f3f3',
  // },
  // lastTableRow: {
  //   borderBottom: '2px solid #009879',
  // },
  // activeRow: {
  //   fontWeight: 'bold',
  //   color: '#009879',
  // },
}));

export const MainTable: React.FC<Props> = ({ rows, title, managersList }) => {
  const classes = useStyles();
  const [statFilters, setStatFilters] = React.useState<string[]>([]);
  const [jobsInterestedIn, setjobsInterestedIn] = React.useState<string[]>([]);
  const [locationFilters, setLocationFilters] = React.useState<string[]>([]);
  const [generalWorkersFilters, setGeneralWorkersFilters] = React.useState<
    string[]
  >([]);
  const [drivingFilters, setDrivingFilters] = React.useState<string[]>([]);
  const [forkliftFilters, setForkliftFilters] = React.useState<string[]>([]);
  const [cncOperatorFilters, setCncOperatorFilters] = React.useState<string[]>(
    []
  );
  const [welderFilters, setWelderFilters] = React.useState<string[]>([]);
  const [warehouseFilters, setWarehouseFilters] = React.useState<string[]>([]);
  const [officeFilters, setOfficeFilters] = React.useState<string[]>([]);
  const [genderFilters, setGenderFilters] = React.useState<string[]>([]);
  const [search, setSearch] = React.useState<string>("");
  const [data, setData] = React.useState<projectionsData | null>(null);
  const [dateFilter, setDateFilter] = React.useState(false);
  const [showAddManagerForm, setShowAddManagerForm] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [startDateFilter, setStartDateFilter] = React.useState<Date>(
    new Date()
  );
  const [dateRangeActivate, setDateRangeActivate] = React.useState(false);
  const [endDateFilter, setEndDateFilter] = React.useState<Date>(new Date());
  const [managersListOpen, setManagersListOpen] = React.useState(false);
  const updateSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const search = e.target.value;
    setSearch(search);
  };

  const updateStatFilters = (newFilters: string[]): void => {
    setStatFilters(newFilters);
  };

  const updatejobsInterestedIn = (newFilters: string[]): void => {
    setjobsInterestedIn(newFilters);
  };

  const updateLocationFilters = (newFilters: string[]): void => {
    setLocationFilters(newFilters);
  };
  const updateDrivingFilters = (newFilters: string[]): void => {
    setDrivingFilters(newFilters);
  };
  const updateForkliftFilters = (newFilters: string[]): void => {
    setForkliftFilters(newFilters);
  };
  const updateCncOperatorFilters = (newFilters: string[]): void => {
    setCncOperatorFilters(newFilters);
  };
  const updateWelderFilters = (newFilters: string[]): void => {
    setWelderFilters(newFilters);
  };
  const updateWarehouseFilters = (newFilters: string[]): void => {
    setWarehouseFilters(newFilters);
  };

  const updateOfficeFilters = (newFilters: string[]): void => {
    setOfficeFilters(newFilters);
  };

  const updateGeneralWorkersFilters = (newFilters: string[]): void => {
    setGeneralWorkersFilters(newFilters);
  };

  const updateGenderFilters = (newFilters: string[]): void => {
    setGenderFilters(newFilters);
  };

  const isSearched = (item: rowData) => {
    return (
      item?.FullName?.toUpperCase().includes(search.toUpperCase()) ||
      item?.Date?.toUpperCase().includes(search.toUpperCase()) 
      // ||
      // item.FullName.split(" ")[1].toUpperCase().includes(search.toUpperCase()) ||
      // item?.PreferredLocation?.split("\n").some((location) =>
      //   location.toUpperCase().includes(search.toUpperCase())
      // ) 
      // ||
      // item.JobsIntrestedIn.split("\n").some((job) =>
      //   job.toUpperCase().includes(search.toUpperCase())
      // ) ||
      // item?.SubCategory1?.toUpperCase().includes(search.toUpperCase()) ||
      // item?.SubCategory2?.toUpperCase().includes(search.toUpperCase())
    );
  };

  const tableFilter = (item: rowData) => {
    const jobsInterestedInArray = item.JobsIntrestedIn.split("\n");
    const preferredLocationArray = item.PreferredLocation.split("\n");
    return (
      (statFilters.length > 0
        ? statFilters.includes(item.PreferredLanguage)
        : true) &&
      (jobsInterestedIn.length > 0
        ? jobsInterestedIn.every((job) => jobsInterestedInArray.includes(job))
        : true) &&
      (locationFilters.length > 0
        ? preferredLocationArray.some((location) =>
            locationFilters.includes(location)
          )
        : true) &&
      (genderFilters.length > 0 ? genderFilters.includes(item.Gender) : true) &&
      isSearched(item) &&
      (dateRangeActivate
        ? moment(startDateFilter).format("L") <=
            moment(new Date(item.Date)).format("L") &&
          moment(endDateFilter).format("L") >=
            moment(new Date(item.Date)).format("L")
        : true) &&
      (drivingFilters.length > 0
        ? drivingFilters.includes(item.SubCategory1 ?? "") ||
          drivingFilters.includes(item.SubCategory2 ?? "")
        : true) &&
      (forkliftFilters.length > 0
        ? forkliftFilters.includes(item.SubCategory1 ?? "") ||
          forkliftFilters.includes(item.SubCategory2 ?? "")
        : true) &&
      (cncOperatorFilters.length > 0
        ? cncOperatorFilters.includes(item.SubCategory1 ?? "") ||
          cncOperatorFilters.includes(item.SubCategory2 ?? "")
        : true) &&
      (welderFilters.length > 0
        ? welderFilters.includes(item.SubCategory1 ?? "") ||
          welderFilters.includes(item.SubCategory2 ?? "")
        : true) &&
      (warehouseFilters.length > 0
        ? warehouseFilters.includes(item.SubCategory1 ?? "") ||
          warehouseFilters.includes(item.SubCategory2 ?? "")
        : true) &&
      (officeFilters.length > 0
        ? officeFilters.includes(item.SubCategory1 ?? "") ||
          officeFilters.includes(item.SubCategory2 ?? "")
        : true) &&
      (generalWorkersFilters.length > 0
        ? generalWorkersFilters.includes(item.SubCategory1 ?? "") ||
          generalWorkersFilters.includes(item.SubCategory2 ?? "")
        : true) &&
      !item.FullName.includes("+")
    );
  };

  const isFilterActive =
    statFilters.length > 0 ||
    jobsInterestedIn.length > 0 ||
    locationFilters.length > 0 ||
    genderFilters.length > 0 ||
    dateRangeActivate ||
    drivingFilters.length > 0 ||
    forkliftFilters.length > 0 ||
    cncOperatorFilters.length > 0 ||
    welderFilters.length > 0 ||
    warehouseFilters.length > 0 ||
    officeFilters.length > 0 ||
    generalWorkersFilters.length > 0 ||
    search.trim() !== "";

  const resetFilters = () => {
    setStatFilters([]);
    setjobsInterestedIn([]);
    setLocationFilters([]);
    setGeneralWorkersFilters([]);
    setDrivingFilters([]);
    setForkliftFilters([]);
    setCncOperatorFilters([]);
    setWelderFilters([]);
    setWarehouseFilters([]);
    setOfficeFilters([]);
    setGenderFilters([]);
    setSearch("");
    setStartDateFilter(new Date());
    setEndDateFilter(new Date());
    setDateRangeActivate(false);
  };

  const openManagerForm = () => {
    setShowAddManagerForm(true);
  };
  const closeManagerForm = () => {
    setShowAddManagerForm(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const openDateFilter = () => {
    setDateFilter(true);
  };
  const closeDateFilter = () => {
    setDateFilter(false);
  };

  const dateRangeSelector = (date: any) => {
    setDateRangeActivate(true);
    setStartDateFilter(date.selection.startDate);
    setEndDateFilter(date.selection.endDate);
    console.log(date);
  };

  const dateSelectionRange = {
    startDate: startDateFilter,
    endDate: endDateFilter,
    key: "selection",
  };

  const dateComponent = (item: any) => {
    const dateString = item;
    const dateObj = new Date(dateString);

    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "short" });
    const year = dateObj.getFullYear();

    // Format the components as needed (e.g., "Jul 15, 2023")
    return `${month} ${day}, ${year}`;
  };

  const openManagersList = () => {
    setManagersListOpen(true);
  };

  const closeManagersList = () => {
    setManagersListOpen(false);
  };

  const itemsPerPage = 10; // Number of rows per page
  const [currentPage, setCurrentPage] = React.useState(1);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    newPage: number
  ) => {
    setCurrentPage(newPage);
  };

  const sortedManagersList = managersList.slice().sort((a, b) => {
    return a.Username.localeCompare(b.Username);
  });

  return (
    <div className={classes.root}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h4 style={{ display: "inline-block" }}>{title}</h4>
        <div>
          {isFilterActive && (
            <button className={classes.resetButtonStyle} onClick={resetFilters}>
              <FontAwesomeIcon icon={faUndo} className="resetButtonIcon" />{" "}
              Reset Filters
            </button>
          )}
        </div>
        <div className={classes.buttonContainer}>
          <button
            className={classes.managersListButton}
            onClick={openManagersList}
          >
            Managers List
          </button>
          <button className={classes.managerButton} onClick={openManagerForm}>
            Add Managers
          </button>
        </div>
      </div>
      <div
        style={{
          marginBottom: "1px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            flexFlow: "row nowrap",
            paddingBottom: "4px",
          }}
        >
          <button className={classes.dateFilterButton} onClick={openDateFilter}>
            Date Filter
          </button>
          {dateRangeActivate && (
            <button
              onClick={() => {
                setDateRangeActivate(false);
              }}
              style={{
                background: "none",
                cursor: "pointer",
              }}
              title="Undo Filter"
            >
              <FontAwesomeIcon
                icon={faUndo}
                style={{
                  paddingLeft: "4px",
                  color: "#f4553c",
                }}
              />
            </button>
          )}
        </div>

        <div style={{ display: "inline-block" }}>
          <span>Search:&nbsp;</span>

          <input
            type="text"
            value={search}
            onChange={updateSearch}
            className={classes.search}
          />
        </div>
      </div>
      <div className="tableFilters">
        <div>
          <label>Language:&nbsp;</label>
          <FilterGroup
            options={[
              ...Array.from(
                new Set(rows.flatMap((item) => item.PreferredLanguage))
              ),
            ]}
            filters={statFilters}
            onChange={updateStatFilters}
            menuDisplay={false}
          />
        </div>
        <div>
          <label>Gender:&nbsp;</label>
          <FilterGroup
            options={[
              ...Array.from(
                new Set(
                  rows.flatMap((item) => {
                    return item.Gender;
                  })
                )
              ),
            ]}
            filters={genderFilters}
            onChange={updateGenderFilters}
            menuDisplay={false}
          />
        </div>
      </div>
      <div className="tableFilters">
        <div>
          <label>Location:&nbsp;</label>
          <FilterGroup
            options={[
              ...Array.from(
                new Set(
                  rows.flatMap((item) => item.PreferredLocation.split("\n"))
                )
              ),
            ]}
            filters={locationFilters}
            onChange={updateLocationFilters}
            menuDisplay={true}
          />
        </div>
        <div>
          <label>Jobs:&nbsp;</label>
          <FilterGroup
            options={[
              ...Array.from(
                new Set(
                  rows.flatMap((item) => {
                    return item.JobsIntrestedIn.split("\n");
                  })
                )
              ),
            ]}
            filters={jobsInterestedIn}
            onChange={updatejobsInterestedIn}
            menuDisplay={true}
          />
        </div>
      </div>
      <div
        className="tableFilters"
        style={{ display: "flex", justifyContent: "end" }}
      >
        {jobsInterestedIn.includes("General Labour") && (
          <div>
            <label>General Workers:&nbsp;</label>
            <FilterGroup
              options={[
                ...Array.from(
                  new Set(
                    rows.flatMap((item) => {
                      const valuesToMatch = [
                        "Packaging",
                        "Heavy Lifting",
                        "Sorting",
                        "Sanitation",
                        "Warehouse",
                        "Assembly",
                        "Production Line",
                      ];
                      const subCategories = [
                        item.SubCategory1,
                        item.SubCategory2,
                      ].filter(
                        (subCategory) => subCategory !== null
                      ) as string[];
                      const matchingSubCategories = subCategories.filter(
                        (subCategory) => valuesToMatch.includes(subCategory)
                      );
                      return matchingSubCategories;
                    })
                  )
                ),
              ]}
              filters={generalWorkersFilters}
              onChange={updateGeneralWorkersFilters}
              menuDisplay={false}
            />
          </div>
        )}
      </div>

      <div
        className="tableFilters"
        style={{ display: "flex", justifyContent: "end" }}
      >
        {jobsInterestedIn.includes("Driving") && (
          <div>
            <label>Driving:&nbsp;</label>
            <FilterGroup
              options={[
                ...Array.from(
                  new Set(
                    rows.flatMap((item) => {
                      const valuesToMatch = [
                        "G Driver",
                        "GZ Driver",
                        "DZ Driver",
                        "G Driver with own car",
                        "AZ Driver",
                        "Sorting",
                      ];
                      const subCategories = [
                        item.SubCategory1,
                        item.SubCategory2,
                      ].filter(
                        (subCategory) => subCategory !== null
                      ) as string[];
                      const matchingSubCategories = subCategories.filter(
                        (subCategory) => valuesToMatch.includes(subCategory)
                      );
                      return matchingSubCategories;
                    })
                  )
                ),
              ]}
              filters={drivingFilters}
              onChange={updateDrivingFilters}
              menuDisplay={false}
            />
          </div>
        )}
      </div>
      <div
        className="tableFilters"
        style={{ display: "flex", justifyContent: "end" }}
      >
        {jobsInterestedIn.includes("Forklift") && (
          <div>
            <label>Forklift:&nbsp;</label>
            <FilterGroup
              options={[
                ...Array.from(
                  new Set(
                    rows.flatMap((item) => {
                      const valuesToMatch = [
                        "Forklift",
                        "Walkie Operator",
                        "Raymond Reach Operator",
                        "Counter Balance Propane",
                        "Counter Balance Electric",
                        "Order Picker",
                        "Pallet Picker",
                      ];
                      const subCategories = [
                        item.SubCategory1,
                        item.SubCategory2,
                      ].filter(
                        (subCategory) => subCategory !== null
                      ) as string[];
                      const matchingSubCategories = subCategories.filter(
                        (subCategory) => valuesToMatch.includes(subCategory)
                      );
                      return matchingSubCategories;
                    })
                  )
                ),
              ]}
              filters={forkliftFilters}
              onChange={updateForkliftFilters}
              menuDisplay={false}
            />
          </div>
        )}
      </div>
      <div
        className="tableFilters"
        style={{ display: "flex", justifyContent: "end" }}
      >
        {jobsInterestedIn.includes("CNC Operator") && (
          <div>
            <label>CNC Operator:&nbsp;</label>
            <FilterGroup
              options={[
                ...Array.from(
                  new Set(
                    rows.flatMap((item) => {
                      const valuesToMatch = [
                        "Lathe Machine Operator",
                        "Milling Machine Operator",
                        "Laser Machine Operator",
                        "Plasma Cutting Machine",
                      ];
                      const subCategories = [
                        item.SubCategory1,
                        item.SubCategory2,
                      ].filter(
                        (subCategory) => subCategory !== null
                      ) as string[];
                      const matchingSubCategories = subCategories.filter(
                        (subCategory) => valuesToMatch.includes(subCategory)
                      );
                      return matchingSubCategories;
                    })
                  )
                ),
              ]}
              filters={cncOperatorFilters}
              onChange={updateCncOperatorFilters}
              menuDisplay={false}
            />
          </div>
        )}
      </div>
      <div
        className="tableFilters"
        style={{ display: "flex", justifyContent: "end" }}
      >
        {jobsInterestedIn.includes("Welder") && (
          <div>
            <label>Welder:&nbsp;</label>
            <FilterGroup
              options={[
                ...Array.from(
                  new Set(
                    rows.flatMap((item) => {
                      const valuesToMatch = [
                        "Tig Welder",
                        "Mig Welder",
                        "ROD Welder",
                        "Gas Welder",
                      ];
                      const subCategories = [
                        item.SubCategory1,
                        item.SubCategory2,
                      ].filter(
                        (subCategory) => subCategory !== null
                      ) as string[];
                      const matchingSubCategories = subCategories.filter(
                        (subCategory) => valuesToMatch.includes(subCategory)
                      );
                      return matchingSubCategories;
                    })
                  )
                ),
              ]}
              filters={welderFilters}
              onChange={updateWelderFilters}
              menuDisplay={false}
            />
          </div>
        )}
      </div>
      <div
        className="tableFilters"
        style={{ display: "flex", justifyContent: "end" }}
      >
        {jobsInterestedIn.includes("Warehouse") && (
          <div>
            <label>Warehouse:&nbsp;</label>
            <FilterGroup
              options={[
                ...Array.from(
                  new Set(
                    rows.flatMap((item) => {
                      const valuesToMatch = [
                        "Warehouse Supervisor",
                        "Shipping/Receiving",
                      ];
                      const subCategories = [
                        item.SubCategory1,
                        item.SubCategory2,
                      ].filter(
                        (subCategory) => subCategory !== null
                      ) as string[];
                      const matchingSubCategories = subCategories.filter(
                        (subCategory) => valuesToMatch.includes(subCategory)
                      );
                      return matchingSubCategories;
                    })
                  )
                ),
              ]}
              filters={warehouseFilters}
              onChange={updateWarehouseFilters}
              menuDisplay={false}
            />
          </div>
        )}
      </div>
      <div
        className="tableFilters"
        style={{ display: "flex", justifyContent: "end" }}
      >
        {jobsInterestedIn.includes("Office") && (
          <div>
            <label>Office:&nbsp;</label>
            <FilterGroup
              options={[
                ...Array.from(
                  new Set(
                    rows.flatMap((item) => {
                      const valuesToMatch = [
                        "Office Admin",
                        "Receptionist",
                        "Call Centre Executive",
                        "Book Keeper",
                        "Payroll Assistant",
                      ];
                      const subCategories = [
                        item.SubCategory1,
                        item.SubCategory2,
                      ].filter(
                        (subCategory) => subCategory !== null
                      ) as string[];
                      const matchingSubCategories = subCategories.filter(
                        (subCategory) => valuesToMatch.includes(subCategory)
                      );
                      return matchingSubCategories;
                    })
                  )
                ),
              ]}
              filters={officeFilters}
              onChange={updateOfficeFilters}
              menuDisplay={false}
            />
          </div>
        )}
      </div>
      <div>
        <Table layout="auto">
          <TableHeader />
          <tbody>
            {rows
              .filter(tableFilter)
              .slice(startIndex, endIndex)
              .map((row, id) => {
                return (
                  <tr
                    key={id}
                    onClick={() => {
                      setData(row);
                      handleOpen();
                    }}
                  >
                    {/* <td>
                    <span>{row.Entry_id}</span>
                  </td> */}
                    <td>
                      <span>{row.FullName}</span>
                    </td>
                    {/* <td>
                    <span>{row.Address}</span>
                  </td> */}
                    <td>
                      <span>{row.Email}</span>
                    </td>
                    <td>
                      <span>{row.Status}</span>
                    </td>
                    <td>
                      <span>{row.PhoneNo}</span>
                    </td>
                    <td>
                      <span>{row.DateOfBirth}</span>
                    </td>
                    <td>
                      <span>{row.Gender}</span>
                    </td>
                    <td>
                      <span>{row.PreferredLanguage}</span>
                    </td>
                    {/* <td>
                    <span>{row.PreviousEmpolyer1}</span>
                  </td>
                  <td>
                    <span>{row.PreviousEmpolyer1Address}</span>
                  </td>
                  <td>
                    <span>{row.ExperienceEmpolyer1}</span>
                  </td>
                  <td>
                    <span>{row.TypeOfWorkEmpolyer1}</span>
                  </td>
                  <td>
                    <span>{row.PreviousEmpolyer2}</span>
                  </td>
                  <td>
                    <span>{row.PreviousEmpolyer2Address}</span>
                  </td>
                  <td>
                    <span>{row.ExperienceEmpolyer2}</span>
                  </td>
                  <td>
                    <span>{row.TypeOfWorkEmpolyer2}</span>
                  </td> */}
                    <td>
                      <span>
                        {row.JobsIntrestedIn.split("\n")[0]}: {row.SubCategory1}
                      </span>
                      <br />
                      <span>
                        {row.JobsIntrestedIn.split("\n")[1]}: {row.SubCategory2}
                      </span>
                    </td>
                    <td>
                      <span>
                        {row.PreferredLocation.split("\n").join(", ")}
                      </span>
                    </td>
                    <td>
                      <span
                        style={{
                          color: "black",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onMouseEnter={(e) =>
                          ((e.target as HTMLInputElement).style.color =
                            "lightsalmon")
                        }
                        onMouseLeave={(e) =>
                          ((e.target as HTMLInputElement).style.color = "black")
                        }
                      >
                        View Profile
                      </span>
                    </td>
                    <td>
                      <a
                        style={{ color: "inherit" }}
                        href={row.IdCard}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e: any) => {
                          e.stopPropagation();
                        }}
                      >
                        <FontAwesomeIcon icon={faIdCard} size="2x" />
                      </a>
                    </td>
                    <td>
                      <a
                        style={{ color: "inherit" }}
                        href={row.Cv}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e: any) => {
                          e.stopPropagation();
                        }}
                      >
                        <FontAwesomeIcon icon={faFile} size="2x" />
                      </a>
                    </td>
                    <td>
                      <span>{dateComponent(row.Date)}</span>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
        />
      </div>
      <Modal open={open} onClose={handleClose} className={classes.modal}>
        <Box className={classes.content}>
          {data ? (
            <div className="profile-card">
              <div className="column">
                <h1 className="profileName">
                  {data.FullName}
                  <p
                    style={{
                      fontSize: "12px",
                      paddingTop: "8px",
                      paddingLeft: "3px",
                    }}
                  >
                    Created at: {data.Date}
                  </p>
                </h1>
                <div className="profileSection">
                  <h3>Contact Information</h3>
                  <p>
                    <strong>Email:</strong> {data.Email}
                  </p>
                  <p>
                    <strong>Phone No:</strong> {data.PhoneNo}
                  </p>
                  <p>
                    <strong>Address:</strong> {data.Address}
                  </p>
                </div>
                <div className="profileSection">
                  <h3>Personal Information</h3>
                  <p>
                    <strong>Status:</strong> {data.Status}
                  </p>
                  <p>
                    <strong>Date of Birth:</strong> {data.DateOfBirth}
                  </p>
                  <p>
                    <strong>Gender:</strong> {data.Gender}
                  </p>
                  <p>
                    <strong>Preferred Language:</strong>{" "}
                    {data.PreferredLanguage}
                  </p>
                </div>
                <div className="profileSection">
                  <h3>Job Preferences</h3>
                  <p>
                    <strong>Job Category 1:</strong>{" "}
                    {data.JobsIntrestedIn.split("\n")[0]}{" "}
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      style={{ color: "#4682b4 " }}
                    />{" "}
                    {data.SubCategory1}
                  </p>
                  <p>
                    <b>Prev Employer:</b> {data.PreviousEmployerSubCategory1} |{" "}
                    <b>Years of Experience: </b>
                    {data.ExperienceSubCategory1}
                  </p>
                  <p>
                    <strong>Job Category 2:</strong>{" "}
                    {data.JobsIntrestedIn.split("\n")[1]}{" "}
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      style={{ color: "#4682b4 " }}
                    />{" "}
                    {data.SubCategory2}
                  </p>
                  <p>
                    <b>Prev Employer:</b> {data.PreviousEmployerSubCategory2} |{" "}
                    <b>Years of Experience: </b>
                    {data.ExperienceSubCategory2}
                  </p>
                  <p>
                    <strong>Preferred Location:</strong>{" "}
                    {data.PreferredLocation.split("\n").join(", ")}
                  </p>
                </div>
              </div>
              <div className="column">
                <div className="profileSection">
                  <h3>Employment History</h3>
                  <p>
                    <strong>Previous Employer 1:</strong>{" "}
                    {data.PreviousEmployer1}
                  </p>
                  <p>
                    <strong>Address:</strong> {data.PreviousEmployer1Address}
                  </p>
                  <p>
                    <strong>Experience at Employer 1:</strong>{" "}
                    {data.ExperienceEmployer1}
                  </p>
                  <p>
                    <strong>Type of Work at Employer 1:</strong>{" "}
                    {data.TypeOfWorkEmployer1}
                  </p>
                  <p>
                    <strong>Previous Employer 2:</strong>{" "}
                    {data.PreviousEmployer2}
                  </p>
                  <p>
                    <strong>Address:</strong> {data.PreviousEmployer2Address}
                  </p>
                  <p>
                    <strong>Experience at Employer 2:</strong>{" "}
                    {data.ExperienceEmployer2}
                  </p>
                  <p>
                    <strong>Type of Work at Employer 2:</strong>{" "}
                    {data.TypeOfWorkEmployer2}
                  </p>
                </div>
                <div className="profileSection">
                  <h3>Attachments</h3>
                  <span className="iconBlock">
                    <a
                      style={{
                        color: "inherit",
                        textAlign: "center",
                        display: "block",
                      }}
                      href={data.IdCard}
                      target="_blank"
                      rel="noreferrer"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faIdCard}
                        className="fonticon"
                        size="3x"
                      />
                      <h5 style={{ fontSize: "0.7rem" }}>ID Card</h5>
                    </a>
                  </span>
                  <span className="iconBlock">
                    <a
                      style={{
                        color: "inherit",
                        textAlign: "center",
                        display: "block",
                      }}
                      href={data.Cv}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FontAwesomeIcon
                        icon={faFile}
                        className="fonticon"
                        size="3x"
                      />
                      <h4 style={{ fontSize: "0.7rem" }}>CV</h4>
                    </a>
                  </span>
                  {data.JobsIntrestedIn.split("\n").includes("Driving") && (
                    <>
                      <span className="iconBlock">
                        <a
                          style={{
                            color: "inherit",
                            textAlign: "center",
                            display: "block",
                          }}
                          href={data.DrivingLicense}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FontAwesomeIcon
                            icon={faFile}
                            className="fonticon"
                            size="3x"
                          />
                          <h4 style={{ fontSize: "0.7rem" }}>
                            Driving License
                          </h4>
                        </a>
                      </span>
                      <span className="iconBlock">
                        <a
                          style={{
                            color: "inherit",
                            textAlign: "center",
                            display: "block",
                          }}
                          href={data.DrivingAbstract}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FontAwesomeIcon
                            icon={faFile}
                            className="fonticon"
                            size="3x"
                          />
                          <h4 style={{ fontSize: "0.7rem" }}>
                            Driving Abstract
                          </h4>
                        </a>
                      </span>
                      <span className="iconBlock">
                        <a
                          style={{
                            color: "inherit",
                            textAlign: "center",
                            display: "block",
                          }}
                          href={data.PassportSizePhoto}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FontAwesomeIcon
                            icon={faFile}
                            className="fonticon"
                            size="3x"
                          />
                          <h4 style={{ fontSize: "0.7rem"}}>
                            Passport Size Photo
                          </h4>
                        </a>
                      </span>
                      <span className="iconBlock">
                        <a
                          style={{
                            color: "inherit",
                            textAlign: "center",
                            display: "block",
                          }}
                          href={data.WorkPermit}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FontAwesomeIcon
                            icon={faFile}
                            className="fonticon"
                            size="3x"
                          />
                          <h4 style={{ fontSize: "0.7rem" }}>Work Permit</h4>
                        </a>
                      </span>
                      <span className="iconBlock">
                        <a
                          style={{
                            color: "inherit",
                            textAlign: "center",
                            display: "block",
                          }}
                          href={data.SinPaper}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FontAwesomeIcon
                            icon={faFile}
                            className="fonticon"
                            size="3x"
                          />
                          <h4 style={{ fontSize: "0.7rem" }}>Sin Paper</h4>
                        </a>
                      </span>
                      <span className="iconBlock">
                        <a
                          style={{
                            color: "inherit",
                            textAlign: "center",
                            display: "block",
                          }}
                          href={data.VoidCheque}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FontAwesomeIcon
                            icon={faFile}
                            className="fonticon"
                            size="3x"
                          />
                          <h4 style={{ fontSize: "0.7rem" }}>Void Cheque</h4>
                        </a>
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div>No Data</div>
          )}
        </Box>
      </Modal>
      <Modal
        open={showAddManagerForm}
        onClose={closeManagerForm}
        className={classes.modal}
      >
        <Box>
          <RegisterModal onClose={closeManagerForm} />
        </Box>
      </Modal>
      <Modal open={dateFilter} onClose={closeDateFilter}>
        <Box className={classes.dateFilterBox}>
          <DateRangePicker
            ranges={[dateSelectionRange]}
            onChange={dateRangeSelector}
            months={2}
            direction="horizontal"
            className="dateRangeDesktop"
          />
          <DateRangePicker
            ranges={[dateSelectionRange]}
            onChange={dateRangeSelector}
            months={0}
            showDateDisplay={false}
            showMonthAndYearPickers={false}
            showMonthArrow={false}
            direction="vertical"
            className="dateRangeMobile"
          />
        </Box>
      </Modal>
      <Modal
        open={managersListOpen}
        onClose={closeManagersList}
        className={classes.managersListModal}
      >
        <Box className={classes.managersListBox}>
          <table className={classes.styledTable}>
            <thead>
              <tr>
                <th>#</th>
                <th>Username</th>
              </tr>
            </thead>
            <tbody>
              {sortedManagersList.map((row, id) => {
                return (
                  <tr key={id}>
                    <td>{id + 1}</td>
                    <td>
                      <span>
                        <b>{row.Username}</b>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Box>
      </Modal>
    </div>
  );
};
